import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/Enlightenment_&_Revolutions_-_Haitian_Revolution.png';

function HistoryPageHaitianRevolution() {
  return (
    <TopicPage
      topicKey="Haitian Revolution"
      title="History: Haitian Revolution"
      backgroundImage={bg}
      startRoute="/History-Haitian-Revolution-Go"
      scrollLabels={[
        "Slave Uprising",
        "Toussaint Louverture",
        "Haiti’s Independence"
      ]}
      backRoute="/history-age-of-revolutions"
      backLabel="← Return to topics"
      backButtonClassName="journey-button special"
      backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageHaitianRevolution;
